import { Injectable, Inject } from '@angular/core';
//import {Http, RequestOptions, RequestOptionsArgs, ResponseContentType, Headers} from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, of, throwError } from 'rxjs';
import { map, merge, catchError, mergeMap  } from 'rxjs/operators';
import { EnvConfigService, EnvConfig } from './smart-form-lib.module';

@Injectable({
  providedIn: 'root'
})
export class SmartFormLibService {

  constructor(private http: HttpClient, @Inject(EnvConfigService) private config: EnvConfig) {     
  }
  
    getFlow(flowId): Observable<any> {
      // OLD URL
      //let flow$ = this.http.get(this.config.api + '/flows/details?flowId='+flowId)//, this.addOptions())      
      let flow$ = this.http.get(this.config.api + `/flows/${flowId}`)
      .pipe(map((flow:any) => {
          console.log(`Org FlowId:${flow.id}`);
          return flow;
      }));
      return flow$;
    }

    deployFlow(flow,accessCode): Observable<any> {
      //let _flow = JSON.parse(JSON.stringify(flow));
      for(let node of flow.nodes){
        if(node.settings==undefined)
          node.settings = {};
        node.settings["__verb"]=node.verb;
      }
      let flow$ = this.http.post(`${this.config.api}/flows/deploy?access=${accessCode}`, {localeId: "en-US", flow:flow})//, this.addOptions())      
      .pipe(map((data:any) => 
      {
        flow.id = data.flow.id;
        flow.flowId = data.flow.flowId;
        console.log(`Deployed FlowId:${flow.id}`);    
        return flow.id;
      }))
      .pipe(catchError(res => {      
        let jRes = res;
        if(jRes.error!=undefined && jRes.error.statusCode!=undefined) {
          let eResponse = jRes.error;
          if(eResponse.statusCode == 400) {
            if(eResponse.data!=undefined){
              eResponse.data.validations = eResponse.errors;              
              return of(eResponse.data);
            }
          }
        }
        else 
          return throwError(jRes);
      }));
      return flow$;
    }    
  
    pulledAudioList = [];
    getAudioList(): Observable<any> {      
      let audio$ = this.http.get(this.config.api + '/audios')//, this.addOptions())      
      .pipe(map((data:any) => 
        {
          if(data && data.length > 0){
            this.pulledAudioList = data;
            return data;
          }
          else {
            this.pulledAudioList = [];
            return [];
          }
        }
      )).pipe(catchError(err=>{
        return [];
      }));
      return audio$;
    }

  //   addOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
  //     // ensure request options and headers are not null
  //     options = options || new RequestOptions();
  //     options.headers = options.headers || new Headers();
  //     options.headers.append('userid', "campaignDeploy");
  //     options.headers.append('authorization', "JOALznhZ/0SknlBowjGpfKga4DJ86AvBTzHV6wRawtg=");

  //     return options;
  // }
}
